var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArticle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 122,
    viewBox: "0 0 123 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 25,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#FDC48C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17714_83517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.125 40.125H44C43.2266 40.125 42.625 40.7695 42.625 41.5V55.9375C42.625 56.3242 42.2812 56.625 41.9375 56.625C41.5508 56.625 41.25 56.3242 41.25 55.9375V42.875H39.875C39.1016 42.875 38.5 43.5195 38.5 44.25V56.625C38.5 58.1719 39.7031 59.375 41.25 59.375H57.75C59.2539 59.375 60.5 58.1719 60.5 56.625V41.5C60.5 40.7695 59.8555 40.125 59.125 40.125ZM50.1875 56.625H46.0625C45.6758 56.625 45.375 56.3242 45.375 55.9375C45.375 55.5938 45.6758 55.25 46.0625 55.25H50.1875C50.5312 55.25 50.875 55.5938 50.875 55.9375C50.875 56.3242 50.5312 56.625 50.1875 56.625ZM50.1875 52.5H46.0625C45.6758 52.5 45.375 52.1992 45.375 51.8125C45.375 51.4688 45.6758 51.125 46.0625 51.125H50.1875C50.5312 51.125 50.875 51.4688 50.875 51.8125C50.875 52.1992 50.5312 52.5 50.1875 52.5ZM57.0625 56.625H52.9375C52.5508 56.625 52.25 56.3242 52.25 55.9375C52.25 55.5938 52.5508 55.25 52.9375 55.25H57.0625C57.4062 55.25 57.75 55.5938 57.75 55.9375C57.75 56.3242 57.4062 56.625 57.0625 56.625ZM57.0625 52.5H52.9375C52.5508 52.5 52.25 52.1992 52.25 51.8125C52.25 51.4688 52.5508 51.125 52.9375 51.125H57.0625C57.4062 51.125 57.75 51.4688 57.75 51.8125C57.75 52.1992 57.4062 52.5 57.0625 52.5ZM57.75 47.6875C57.75 48.0742 57.4062 48.375 57.0625 48.375H46.0625C45.6758 48.375 45.375 48.0742 45.375 47.6875V43.5625C45.375 43.2188 45.6758 42.875 46.0625 42.875H57.0625C57.4062 42.875 57.75 43.2188 57.75 43.5625V47.6875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17714_83517",
    x: -24,
    y: -22.375,
    width: 147,
    height: 144.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.329412 0 0 0 0 0.529412 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17714_83517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17714_83517",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.29fa1028.svg";
export { ForwardRef as ReactComponent };